import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Target } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { ObjectivesPage } from "./pages/ObjectivesPage";
import { QuarterAdminPage } from "./pages/QuarterAdminPage";

export const objectivesModule: FeatureModule = {
  key: "objectives",
  nav: {
    label: "Objectives",
    icon: Target,
    to: "/objectives",
    requires: "objectives.read",
    order: 100,
    group: "Strategy",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/objectives",
      component: guarded("objectives.read", ObjectivesPage),
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/objectives/admin",
      component: guarded("objectives.admin", QuarterAdminPage),
    }),
  ] as unknown as AnyRoute[],
};
